var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.855,
    x2: 192.859,
    xlinkHref: "#lg1",
    y1: 322.746,
    y2: 407.978
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.159,
    x2: 499.163,
    xlinkHref: "#lg1",
    y1: 322.746,
    y2: 407.978
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.253,
    x2: 471.159,
    xlinkHref: "#lg1",
    y1: 308.9,
    y2: 471.806
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.254,
    x2: 298.587,
    xlinkHref: "#lg2",
    y1: 370.05,
    y2: 180.717
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a7587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092a40"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.155,
    x2: 379.155,
    xlinkHref: "#lg3",
    y1: 154.983,
    y2: 384.983
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#092a40",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092a40"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.857,
    x2: 310.857,
    xlinkHref: "#lg4",
    y1: 218.6,
    y2: 305.6
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.892,
    x2: 268.731,
    xlinkHref: "#lg3",
    y1: 369.002,
    y2: 398.841
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.312,
    x2: 279.98,
    xlinkHref: "#lg4",
    y1: 386.452,
    y2: 327.554
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.374,
    x2: 410.212,
    xlinkHref: "#lg3",
    y1: 369.002,
    y2: 398.841
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.794,
    x2: 421.462,
    xlinkHref: "#lg4",
    y1: 386.452,
    y2: 327.554
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.225,
    x2: 335.876,
    xlinkHref: "#lg5",
    y1: 444.827,
    y2: 485.034
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.253,
    x2: 318.253,
    xlinkHref: "#lg2",
    y1: 414.406,
    y2: 357.895
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.524,
    x2: 162.524,
    xlinkHref: "#lg4",
    y1: 262.882,
    y2: 61.882
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.862,
    x2: 389.416,
    xlinkHref: "#lg4",
    y1: 218.719,
    y2: 86.388
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.872,
    x2: 214.328,
    xlinkHref: "#lg5",
    y1: 46.841,
    y2: 171.296
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.368,
    x2: 139.368,
    xlinkHref: "#lg6",
    y1: 131.587,
    y2: 238.908
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.253,
    x2: 128.301,
    xlinkHref: "#lg6",
    y1: 180.095,
    y2: 145.142
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.557,
    x2: 73.517,
    xlinkHref: "#lg6",
    y1: 148.747,
    y2: 6.706
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.168,
    x2: 177.567,
    y1: 98.017,
    y2: 98.017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.641,
    x2: 462.97,
    y1: 34.548,
    y2: 157.877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.209,
    x2: 394.209,
    y1: 97.983,
    y2: 167.499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.622 361.03v-30.611c0-19.042 15.437-34.479 34.479-34.479 19.042 0 34.479 15.437 34.479 34.479v30.611c0 19.042-15.437 34.479-34.479 34.479-19.043 0-34.479-15.436-34.479-34.479z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.926 361.03v-30.611c0-19.042 15.437-34.479 34.479-34.479 19.042 0 34.479 15.437 34.479 34.479v30.611c0 19.042-15.437 34.479-34.479 34.479-19.042 0-34.479-15.436-34.479-34.479z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m318.253 510c-88.319 0-159.916-71.596-159.916-159.915v-62.37c0-88.319 71.596-159.915 159.915-159.915 88.319 0 159.915 71.596 159.915 159.915v62.37c.001 88.319-71.595 159.915-159.914 159.915z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.253 127.8c-88.319 0-159.916 71.596-159.916 159.915v15.486l201.363 201.363c68.224-18.26 118.467-80.497 118.467-154.48v-62.37c.001-88.318-71.595-159.914-159.914-159.914z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m398.54 92.719h-97.574c-25.291 0-48.61 8.428-67.314 22.623-10.309-5.642-22.138-8.855-34.719-8.855-40 0-72.426 32.426-72.426 72.426v64.301c0 40 32.426 72.426 72.426 72.426 17.007 0 32.632-5.877 44.991-15.691 16.688 9.961 36.195 15.691 57.042 15.691h97.574c61.558 0 111.46-49.902 111.46-111.46 0-61.559-49.902-111.461-111.46-111.461z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.505 204.179c0-36.267 17.325-68.483 44.146-88.838-10.309-5.642-22.138-8.855-34.719-8.855-40 0-72.426 32.426-72.426 72.426v64.301c0 40 32.426 72.426 72.426 72.426 17.007 0 32.632-5.877 44.991-15.691-32.588-19.451-54.418-55.058-54.418-95.769z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m270.551 377.622c0 12.724-10.315 23.038-23.039 23.038s-23.038-10.315-23.038-23.038c0-12.724 10.315-23.039 23.038-23.039 12.724 0 23.039 10.315 23.039 23.039z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.818 357.013c1.554 3.101 2.43 6.601 2.43 10.306 0 12.724-10.315 23.039-23.039 23.039-3.705 0-7.205-.876-10.306-2.43 3.782 7.549 11.59 12.733 20.609 12.733 12.724 0 23.039-10.315 23.039-23.038 0-9.02-5.184-16.827-12.733-20.61z",
    fill: "url(#SVGID_8_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m412.032 377.622c0 12.724-10.315 23.038-23.039 23.038s-23.038-10.315-23.038-23.038c0-12.724 10.315-23.039 23.038-23.039 12.725 0 23.039 10.315 23.039 23.039z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.299 357.013c1.554 3.101 2.43 6.601 2.43 10.306 0 12.724-10.315 23.039-23.039 23.039-3.705 0-7.205-.876-10.306-2.43 3.782 7.549 11.59 12.733 20.609 12.733 12.724 0 23.039-10.315 23.039-23.038 0-9.02-5.183-16.827-12.733-20.61z",
    fill: "url(#SVGID_10_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m349.982 445.067c-20.111-9.388-43.347-9.388-63.457 0-5.202 2.428-7.528 8.574-5.188 13.816 5.358 11.997 16.955 30.861 36.916 30.861s31.559-18.864 36.916-30.861c2.341-5.243.015-11.388-5.187-13.816z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.253,
    cy: 407.196,
    fill: "url(#SVGID_12_)",
    rx: 20.667,
    ry: 17.796
  })), /*#__PURE__*/React.createElement("path", {
    d: "m278.721 94.954c-16.674 3.38-32.001 10.469-45.07 20.387-10.309-5.642-22.138-8.855-34.719-8.855-40 0-72.426 32.426-72.426 72.426v13.497l111.656 111.656c1.986-1.284 3.914-2.651 5.761-4.117 16.688 9.961 36.195 15.691 57.042 15.691h97.574c28.083 0 53.737-10.39 73.337-27.53z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 204.179c0-61.558-49.902-111.46-111.46-111.46h-93.606c1.095 10.559 4.632 21.108 8.626 31.615 1.333 3.508 3.826 6.558 7.091 8.878 0 0 4.562 4.749 4.826 5.082.934 1.85 1.452 4.911 1.452 7.056v10.118c0 3.088 1.455 5.149 4.08 5.265l133.378 133.377c27.654-20.283 45.613-53.007 45.613-89.931z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.652 29.528c3.811-10.027 13.737-17.672 26.163-20.029 66.779-12.666 134.328-12.666 201.106 0 12.426 2.357 22.352 10.002 26.163 20.029 16.87 44.386 16.868 89.235 0 133.617-2.226 5.856-6.539 10.895-12.218 14.545-6.049 3.888-9.815 10.483-9.815 17.674v15.513c0 7.202-8.707 10.808-13.799 5.716l-19.664-19.664c-5.016-5.016-12.015-7.496-19.075-6.805-50.894 4.978-102.017 2.662-152.698-6.95-12.426-2.357-22.352-10.002-26.163-20.028-16.868-44.383-16.87-89.231 0-133.618z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.495 109.488c1.332 17.921 5.38 35.826 12.157 53.656 3.811 10.027 13.737 17.672 26.163 20.028 50.681 9.613 101.804 11.928 152.698 6.95 7.06-.691 14.059 1.79 19.075 6.805l19.664 19.664c5.092 5.092 13.799 1.486 13.799-5.716v-15.513c0-7.191 3.765-13.787 9.815-17.674 5.679-3.65 9.992-8.689 12.218-14.545 6.777-17.83 10.825-35.736 12.157-53.656h-277.746z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m193.09 190.03c-.53 0-1.05.04-1.58.09-11.93 1.17-23.88 1.93-35.83 2.29l-28.34-28.34c-3.69-2.64-5.049-7.01-5.049-11.74 0-7.82 5.339-13.339 13.159-13.339 4.74 0 8.98 1.389 11.61 5.009z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m272.38 143.7c-1.74 6.49-3.84 12.97-6.3 19.44-2.22 5.86-6.54 10.9-12.21 14.55-6.05 3.89-9.82 10.48-9.82 17.67v15.52c0 7.2-8.71 10.81-13.8 5.71l-19.66-19.66c-4.09-4.09-9.49-6.49-15.17-6.86l-65.86-65.86c-3.29-1.47-3.539-4.87-3.539-11.57 0-11.1 4.401-17.179 8.291-22.029-.08-.12-2.161-1.241-2.241-1.361l-26.16-26.16c-2.69-1.7-3.739-4.58-3.739-8.77 0-10.06 10.549-23.969 35.709-23.969 14.65 0 26.27 3.999 33.06 11.919z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m156.697 94.197c-10.249 8.013-10.435 13.603-10.435 23.292 0 3.54-1.863 7.64-10.994 7.64-7.64 0-10.249-2.795-10.249-12.485 0-16.025 7.081-23.665 12.485-28.323 6.149-5.218 16.584-10.994 16.584-21.057 0-8.572-7.453-12.67-16.771-12.67-19.007 0-14.907 14.347-24.969 14.347-5.031 0-11.18-3.354-11.18-10.621 0-10.062 11.553-24.969 36.708-24.969 23.851 0 39.691 13.23 39.691 30.746s-15.839 30.187-20.87 34.1zm-6.895 58.137c0 7.641-6.335 14.349-14.348 14.349-8.012 0-14.162-6.708-14.162-14.349 0-7.826 6.336-14.347 14.162-14.347 7.827 0 14.348 6.522 14.348 14.347z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.859 37.183c-2.486-6.54-8.96-11.526-17.065-13.064-43.556-8.261-87.615-8.261-131.171 0-8.105 1.537-14.579 6.524-17.065 13.064-11.004 28.951-11.002 58.204 0 87.151 1.452 3.819 4.265 7.107 7.969 9.487 3.946 2.536 6.402 6.838 6.402 11.528v10.118c0 4.697 5.679 7.05 9 3.728l12.826-12.826c3.271-3.271 7.837-4.889 12.442-4.439 33.195 3.247 66.541 1.737 99.597-4.533 8.105-1.537 14.579-6.524 17.065-13.064 11.002-28.946 11.003-58.199 0-87.15z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#43765a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m418.835 74.311h37.593c2.755 0 4.988-2.233 4.988-4.988v-9.976c0-2.755-2.233-4.988-4.988-4.988h-37.593c-2.755 0-4.988 2.233-4.988 4.988v9.976c0 2.755 2.233 4.988 4.988 4.988z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.989 74.311h65.632c2.755 0 4.988-2.233 4.988-4.988v-9.976c0-2.755-2.233-4.988-4.988-4.988h-65.632c-2.755 0-4.988 2.233-4.988 4.988v9.976c0 2.755 2.233 4.988 4.988 4.988z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m369.582 104.363h-37.593c-2.755 0-4.988-2.233-4.988-4.988v-9.976c0-2.755 2.233-4.988 4.988-4.988h37.593c2.755 0 4.988 2.233 4.988 4.988v9.976c0 2.755-2.233 4.988-4.988 4.988z",
    fill: "#43765a"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m303.629 89.337c.869 11.689 3.509 23.368 7.93 34.997 1.452 3.819 4.265 7.107 7.969 9.487 3.946 2.536 6.402 6.838 6.402 11.528v10.118c0 4.697 5.679 7.05 9 3.728l12.826-12.826c3.272-3.271 7.837-4.889 12.442-4.439 33.195 3.247 66.541 1.737 99.597-4.533 8.105-1.537 14.579-6.524 17.065-13.064 4.42-11.63 7.061-23.309 7.929-34.997h-181.16z",
    fill: "url(#SVGID_21_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQa);
export default __webpack_public_path__ + "static/media/icon-qa.c630154a86ec09eab2a695ea1be23b50.svg";
export { ForwardRef as ReactComponent };